import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface LetterIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  active: boolean;
}
function LetterIcon(t0) {
  const $ = _c(19);
  const {
    active
  } = t0;
  const t1 = active ? "rgb(var(--brand-primary))" : "rgb(var(--fill-primary))";
  let t2;
  if ($[0] !== t1) {
    t2 = <path d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t4;
  if ($[2] !== t3) {
    t4 = <path d="M317.892 257.944L446 338.935V173.544L317.892 257.944Z" fill={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t6;
  if ($[4] !== t5) {
    t6 = <path d="M66 173.544V338.935L194.108 257.944L66 173.544Z" fill={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t8;
  if ($[6] !== t7) {
    t8 = <path d="M422.252 125.375H89.752C77.898 125.375 68.493 134.21 66.712 145.586L256 270.298L445.287 145.586C443.506 134.21 434.101 125.375 422.252 125.375Z" fill={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = active ? "rgb(var(--background-secondary))" : "rgb(var(--text-tertiary))";
  let t10;
  if ($[8] !== t9) {
    t10 = <path d="M296.136 272.293L262.536 294.428C260.595 295.699 258.325 296.375 256.005 296.375C253.685 296.375 251.415 295.699 249.474 294.428L215.862 272.269L66.76 366.58C68.589 377.861 77.946 386.625 89.75 386.625H422.25C434.05 386.625 443.411 377.861 445.24 366.58L296.136 272.293Z" fill={t9} />;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t2 || $[12] !== t4 || $[13] !== t6 || $[14] !== t8) {
    t11 = <g clipPath="url(#clip0_1_2)">{t2}{t4}{t6}{t8}{t10}</g>;
    $[10] = t10;
    $[11] = t2;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <defs><clipPath id="clip0_1_2"><rect width="512" height="512" fill="rgb(var(--background-secondary))" /></clipPath></defs>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11) {
    t13 = <svg width="21" height="21" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">{t11}{t12}</svg>;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  return t13;
}
export default LetterIcon;